import React from "react";
import {
  Box,
  Typography,
  Link as MuiLink,
  IconButton,
  Grid,
  Divider,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

function Footer() {
  return (
    <Box sx={{ bgcolor: "black", color: "white", px: { xs: 3, md: 6 }, py: 6 }}>
      <Grid container spacing={4} justifyContent="space-between">

        {/* Quick Links */}
        <Grid item xs={12} md={4} textAlign={{ xs: "center", md: "left" }}>
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Quick Links
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {[
              { label: "Home", path: "/" },
              { label: "About Us", path: "/about" },
              { label: "Careers", path: "/careers" },
              { label: "Apply Now", path: "/apply" },
              { label: "Contact", path: "/contact" },
            ].map((item, i) => (
              <MuiLink
                key={i}
                component={RouterLink}
                to={item.path}
                color="inherit"
                underline="hover"
                sx={{ fontSize: "14px" }}
              >
                {item.label}
              </MuiLink>
            ))}
          </Box>
        </Grid>

        {/* Social Media */}
        <Grid item xs={12} md={4} textAlign="center">
          <Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
            Follow Us
          </Typography>

          <IconButton
            href="https://www.facebook.com/profile.php?id=61581235222116"
            target="_blank"
            sx={{ color: "white" }}
          >
            <FacebookIcon />
          </IconButton>

          <IconButton sx={{ color: "white" }}>
            <InstagramIcon />
          </IconButton>

          <IconButton sx={{ color: "white" }}>
            <LinkedInIcon />
          </IconButton>

          <IconButton
            href="https://wa.me/12362382587"
            target="_blank"
            sx={{ color: "white" }}
          >
            <WhatsAppIcon />
          </IconButton>
        </Grid>

        {/* Contact & Credit */}
        <Grid item xs={12} md={4} textAlign={{ xs: "center", md: "right" }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} LineGuard Security. All rights reserved.
          </Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            📧{" "}
            <MuiLink
              href="mailto:info@lineguardsecurity.ca"
              color="inherit"
              underline="hover"
            >
              info@lineguardsecurity.ca
            </MuiLink>
          </Typography>

          <Typography variant="body2" sx={{ mt: 0.5 }}>
            📞 +1-236-238-2587
          </Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            Made with ❤️
          </Typography>

          <Typography variant="body2" sx={{ mt: 1 }}>
            Website designed & developed by <strong>Nisha</strong>.{" "}
            <MuiLink
              href="mailto:nishaneha9470@gmail.com"
              color="inherit"
              underline="hover"
            >
              Click to contact
            </MuiLink>
          </Typography>
        </Grid>

      </Grid>

      <Divider sx={{ bgcolor: "rgba(255,255,255,0.1)", mt: 4 }} />
    </Box>
  );
}

export default Footer;
